

// function menuScroll() {
//   position = $(window).scrollTop();
  
//   if (position < 50) {
//     $(".nav-bar").removeClass("nav-solid");
//   } else {
//     $(".nav-bar").addClass("nav-solid");
//   }
// }

// menuScroll();

// $(window).on('scroll', function() {
//   menuScroll();
// });

import $ from "jquery";

export const nav = () => {
  // var position = $(window).scrollTop();
  console.log('nav.js loaded');
  var lastOpen = null;
  $('#mobile-hamburger').on('click', function() {
    if ($('.nav-bar').hasClass('nav-open')) {
      $('.nav-bar').removeClass('nav-solid');
      $('.nav-bar').removeClass('nav-open');
      $('body').removeClass('overflow-hidden');
    } else {
      $('.nav-bar').addClass('nav-solid');
      $('.nav-bar').addClass('nav-open');
      $('body').addClass('overflow-hidden');
    }
  });

  $(window).on('resize', function() {
    if ($(window).width() > 1200) {
      $('.nav-bar').removeClass('nav-solid');
      $('.nav-bar').removeClass('nav-open');
      $('body').removeClass('overflow-hidden');

      // menuScroll();
    } else {
      $('.nav-bar').removeClass('nav-solid');
      $('.nav-bar').removeClass('nav-open');
      $('#main-nav').removeClass('show');
      $('body').removeClass('overflow-hidden');

      // menuScroll();
    }

    /** Close menu when we resize to avoid issues */
    // $(".dropdown-toggle").each(function() {
    //   $(this).dropdown('hide');
    // });
    // $('#menu-overlay').hide();

  }).resize();


  // $(".dropdown-toggle").on("show.bs.dropdown", function(event){
  //   console.log('dropdown show');
  //   var navHeight = $('.nav-bar').outerHeight();
  //   var $dropdownMenu = $(event.relatedTarget).parents('li').find('.dropdown-menu');
  //   var dropdownContentHeight = $dropdownMenu.outerHeight() + 150;
  //   var viewportHeight = document.documentElement.clientHeight - navHeight;

  //   if (viewportHeight < dropdownContentHeight) {
  //     $dropdownMenu.css({
  //       'height': 'calc(100vh - '+navHeight+'px)'
  //     });
  //   } else {
  //     $dropdownMenu.css({
  //       'height': 'auto'
  //     });
  //   }
  // });

  // $(".dropdown-toggle").on("hide.bs.dropdown", function(event) {
  //   var $dropdownMenu = $(event.relatedTarget).parents('li').find('.dropdown-menu');
    
  //   $dropdownMenu.css({
  //     'height': 'auto'
  //   });
  // });

  $('.dropdown-toggle').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation(); 
    console.log('dropdown clicked');
    var itemID = $(this).parent().attr('id');
    //show child .dropdown-menu
    $('#' + itemID + ' .dropdown-menu').toggleClass('show');
    //hide other .dropdown-menu
    $('.dropdown-menu').not('#' + itemID + ' .dropdown-menu').removeClass('show');

    if (itemID == lastOpen) {
      //check if .toggle exists

      $('html').toggleClass('overflow-hidden');
      itemID = null;
    } else if (lastOpen == null) {
      $('html').toggleClass('overflow-hidden');
    }
    lastOpen = itemID;
  });

  // $('.dropdown-toggle').on('click', function(e) {
  //   console.log('dropdown stop');
  // });

  // $('#menu-overlay, body').on('click', function(e) {
  //   if ($(e.target).closest('.dropdown-toggle').length === 0) {
  //     $(".dropdown-toggle").each(function() {
  //       $(this).dropdown('hide');
  //     });
  //     $('#menu-overlay').hide();
  //     $('html').removeClass('overflow-hidden');
  //     lastOpen = null;
  //   }
  // });
};